/* global __APP_VERSION__ */
/**
 * The running bundle's version and the deployed one. `__APP_VERSION__` and
 * `version.json` come from the same value at build time (vite.config.ts), so
 * a difference means a newer deployment is live.
 */

export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : 'dev';

/** `version.json` sits beside `index.html`, under the app's base path. */
export const VERSION_URL = `${import.meta.env.BASE_URL}version.json`;

/** The deployed version, or null when the beacon cannot be read (offline, a fallback page). */
export async function fetchDeployedVersion(url: string = VERSION_URL): Promise<string | null> {
  try {
    const response = await fetch(url, { cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) return null;
    const body: unknown = await response.json();
    if (body && typeof body === 'object' && typeof (body as { version?: unknown }).version === 'string') {
      return (body as { version: string }).version;
    }
    return null;
  } catch {
    return null;
  }
}

/** The watcher runs only in a built bundle that knows its version. */
export function watcherEnabled(): boolean {
  return !import.meta.env.DEV && APP_VERSION !== 'dev';
}
